import { elegir } from '../ui/layout-variant.tsx';
import { NutricionMobile } from './Nutricion.mobile.tsx';
import { NutricionDesktop } from './Nutricion.desktop.tsx';

export default elegir(NutricionMobile, NutricionDesktop);
